import React, { useState, useEffect, useRef, useCallback } from "react";

import { getPizhuanList, IPizhuan, updatePizhuan } from "../../api";

import PizhuanItem from "../PizhuanItem";
import Pager from "../Pager";
import Placeholder from "../Placeholder";
import styles from "./PizhuanList.module.css";

import { tenderStatusEnum } from "../../constant"
import { on } from "cluster";

const PAGESIZE = 40;

interface PizhuanListProps {
  venderId: Number;
}
let timer: any = null;
const PizhuanList: React.FC<PizhuanListProps> = props => {
  const { venderId } = props;

  const containerRef = useRef<HTMLDivElement>(null);
  let pizhuanListRef = useRef<IPizhuan[]>([])

  const [pizhuanList, setPizhuanList] = useState<IPizhuan[]>([]);

  const [page, setPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [keyword, setKeyWord] = useState("");
  const [empty, setEmtpy] = useState(false);

  const onVisibilityChange = () => {
    if (document.visibilityState === 'visible') {
      handleUpdatePizhuan()
    }
  }

  useEffect(() => {
    window.addEventListener('visibilitychange', onVisibilityChange);
    return () => {
      window.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [])

  const fetchData = (current?: number) => {
    const params: any = {
      page: current || 1,
      pageSize: PAGESIZE,
      keyword, // 搜索key
      vendorId: '' + venderId, // 商家Id（商家Id需要为string类型）          
    };
    Object.keys(params).forEach(key => {
      if(params[key] === -1 || params[key] === ''){
        delete params[key]
      }
    })

    getPizhuanList(params).then(res => {
      let { data, totalItem } = res
      setTotal(totalItem || 0)
      setEmtpy(!totalItem)
      const list = data && data.length ? data : []
      setPizhuanList(list)
      pizhuanListRef.current = list
      timer && clearInterval(timer)
      if (list.length) {
        timer = setInterval(() => {
          let needUpdateIds: number[] = []
          pizhuanListRef.current.forEach((item: any) => {
            // 非结束状态的项目需要设置倒计时
            if (!tenderStatusEnum.done.includes(item.tenderStatus)) {
              if (item.remainTime >= 1000) {
                item.remainTime -= 1000
              } else {
                needUpdateIds.push(item.id)
              }
            }
          })
          setPizhuanList([...pizhuanListRef.current])
          if (needUpdateIds.length) {
            handleUpdatePizhuan(needUpdateIds)
          }

        }, 1000)
      }
    }).catch(() => {
      setTotal(0)
      setEmtpy(true)
      setPizhuanList([])
      timer && clearInterval(timer)
    })
  }
  
  const handleUpdatePizhuan = (ids?: number[]) => {
    let needUpdateIds = ids
    if (!needUpdateIds) {
      // 没有传入id，默认更新全部
      needUpdateIds = pizhuanList.map(item => item.id)
    }
    if (needUpdateIds) {
      updatePizhuan({
        ids: needUpdateIds
      }).then((res: any) => {
        console.log(res)
        if(res && res.data) {
          Object.keys(res.data).forEach(id => {
            console.log(pizhuanListRef.current)
            pizhuanListRef.current.forEach((item, index) => {
              if (item.id.toString() === id) {
                pizhuanListRef.current[index] = {
                  ...pizhuanListRef.current[index],
                  ...res.data[id]
                }
              }
            })
          })
          setPizhuanList([...pizhuanListRef.current]);
        }
      })
    }
  }

  useEffect(() => {
    setPage(1);
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    keyword,
    page
  ]);

  useEffect(() => {
    const target = containerRef.current as HTMLDivElement;
    const currentTop = target.getBoundingClientRect().top;
    const top = target.offsetTop - 51;
    if (currentTop < 0) {
      window.scrollTo(0, top);
    }
  }, [page]);

  return (
    <div className={styles.container} ref={containerRef}>
      {empty ? (
        <Placeholder text="暂无相关拍品，敬请期待更多上拍～" />
      ) : (
        <div className={styles.items}>
          {pizhuanList.map((pizhuan, index) => (
            <PizhuanItem key={index} pizhuanInfo={pizhuan}/>
          ))}
        </div>
      )}
      <div className={styles.pager}>
        <Pager
          current={page}
          pageSize={PAGESIZE}
          handler={(current) => {
            setPage(current);
            fetchData(current);
          }}
          total={total}
        />
      </div>
    </div>
  );
};

export default PizhuanList;
